import React, { useState, useEffect, useCallback, createRef } from "react";
import BoardList from "./BoardList";
import BoardReg from "./BoardReg";

const Board = (props) => {
  const [status, setStatus] = useState("list");
  const [boardId, setBoardId] = useState("");

  return (
    <>
      {status === "list" ? (
        <BoardList
          menuInfo={props.menuInfo}
          status={status}
          setStatus={setStatus}
          setBoardId={setBoardId}
        />
      ) : (
        <BoardReg
          menuInfo={props.menuInfo}
          status={status}
          setStatus={setStatus}
          boardId={boardId}
        />
      )}
    </>
  );
};

export default Board;
